// hooks/usePermission.js
import { useSelector } from "react-redux"

export function usePermission() {
  const permissions = useSelector((state) => state.user.permissions || [])
  const { user, userType } = useSelector((state) => state.user)

  const hasPermission = (perm) =>
    userType === "INVESTOR" && user.user_type === "SUPER_INVESTOR"
      ? true
      : permissions.includes(perm)

  const hasAnyPermission = (permList = []) =>
    permList.some((perm) =>
      userType === "INVESTOR" && user.user_type === "SUPER_INVESTOR"
        ? true
        : permissions.includes(perm)
    )

  const hasAllPermissions = (permList = []) =>
    permList.every((perm) => permissions.includes(perm))

  return { hasPermission, hasAnyPermission, hasAllPermissions }
}
